import { useTask } from '~/contexts/TaskContext'

export function useTaskId() {
  const { task } = useTask()
  return task?.task_id ?? 0
}
